module.exports = __webpack_public_path__ + "static/favicon-4665df17e55402c9ea3b920eee206a24.ico";